module.exports = __webpack_public_path__ + "img/blueJ_logo _blue.2667a93b.svg";